import { usePrice, useValidation } from '../state/hooks.js';

function formatUSD(n: number): string {
  const sign = n < 0 ? '−' : '';
  return `${sign}$${Math.abs(n).toFixed(2)}`;
}

export function PricePanel() {
  const price = usePrice();
  const validation = useValidation();

  return (
    <section className="price-panel" aria-label="Price breakdown">
      <h2 className="price-panel__title">Price</h2>

      <ul className="price-panel__lines">
        {price.lineItems.map((item, i) => (
          <li key={i} className="price-line">
            <div className="price-line__label">
              <span className="price-line__main">{item.label}</span>
              <span className="price-line__detail">{item.detail}</span>
            </div>
            <span className="price-line__amount">{formatUSD(item.amount)}</span>
          </li>
        ))}
      </ul>

      <div className="price-panel__total">
        <span>Subtotal</span>
        <strong>{formatUSD(price.total)}</strong>
      </div>

      <p className="price-panel__shipping">Shipping calculated at checkout.</p>

      {!validation.ok ? (
        <div className="price-panel__errors" role="alert">
          <strong>Fix before adding to cart:</strong>
          <ul>
            {validation.errors.map((e, i) => (
              <li key={i}>{e.message}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  );
}
